import { useNavigate } from 'react-router-dom';

// Route constants to avoid hardcoded strings
export const ROUTES = {
  // Main routes
  HOME: '/',
  REGISTRATION_DASHBOARD: '/registration-dashboard',

  // Authentication routes
  SIGN_IN: (type) => `/sign-in/${type}`,
  SIGN_IN_STEP_2: '/sign-in-step-2',
  FORGET_PASSWORD: (userRole) => `/forget-password/${userRole}`,
  CHANGE_PASSWORD: '/change-password',
  RESET_PASSWORD: '/reset-password',

  // Registration routes
  ADVISOR_REGISTRATION: '/advisor-registration',
  CLIENT_REGISTRATION: '/client-registration',
  VERIFY_EMAIL: '/verify-email',

  CONTACT_US: '/contact-us',

  // Subscription routes
  SUBSCRIPTION: (roleType) => `/subscription/${roleType}`,
  BUSINESS_SUBSCRIPTION: '/subscription/business',
  BUSINESS_QUESTIONNAIRE: '/subscription/business/questionnarie',
  FAMILY_SUBSCRIPTION: '/subscription/family',
  FAMILY_QUESTIONNAIRE: '/subscription/family/questionnarie',

  // Pricing routes
  PRICING: (roleType, subsType) => `/pricing/${roleType}/${subsType}`,
  PRICING_CLIENT: '/pricing/client',
  PRICING_ADVISOR: '/pricing/advisor',
};

// Navigation utility functions
export const createNavigationUtils = (navigate) => ({
  // Basic navigation
  goTo: (path) => navigate(path),
  goBack: () => navigate(-1),

  // Home navigation
  goHome: () => navigate(ROUTES.HOME),
  goToDashboard: () => navigate(ROUTES.REGISTRATION_DASHBOARD),

  // Authentication navigation
  goToSignIn: (type = 'advisor') => navigate(ROUTES.SIGN_IN(type)),
  goToForgetPassword: (userRole) => navigate(ROUTES.FORGET_PASSWORD(userRole)),
  goToChangePassword: () => navigate(ROUTES.CHANGE_PASSWORD),
  goToResetPassword: () => navigate(ROUTES.RESET_PASSWORD),

  // Registration navigation
  goToAdvisorRegistration: () => navigate(ROUTES.ADVISOR_REGISTRATION),
  goToClientRegistration: () => navigate(ROUTES.CLIENT_REGISTRATION),
  goToVerifyEmail: () => navigate(ROUTES.VERIFY_EMAIL),

  // Contact navigation
  goToContact: () => navigate(ROUTES.CONTACT_US),

  // Subscription navigation
  goToSubscription: (roleType) => navigate(ROUTES.SUBSCRIPTION(roleType)),

  // Pricing navigation
  goToPricing: (roleType, subsType) => navigate(ROUTES.PRICING(roleType, subsType)),
  goToClientPricing: () => navigate(ROUTES.PRICING_CLIENT),
  goToAdvisorPricing: () => navigate(ROUTES.PRICING_ADVISOR),

  goToRegistration: (entityType) => {
    const route = entityType === 'advisor' ? ROUTES.ADVISOR_REGISTRATION : ROUTES.CLIENT_REGISTRATION;
    navigate(route);
  },

  // Back navigation with specific routes
  goBackToHome: () => navigate(ROUTES.HOME),
  goBackToSignIn: (type = 'advisor') => navigate(ROUTES.SIGN_IN(type)),
  goBackToSubscription: (roleType) => navigate(ROUTES.SUBSCRIPTION(roleType)),
});

// Custom hook for navigation
export const useNavigation = () => {
  const navigate = useNavigate();
  return createNavigationUtils(navigate);
};

// Legacy function for backward compatibility
const Navigate = (path) => {
  const navigate = useNavigate();
  navigate(path);
  return { navigate };
};

export default Navigate;